import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, DatePicker, Select, InputNumber } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getFinalPayDetails, doFinalPayCreate, doFinalPayUpdate 
} from "../../../../redux/finalpay/finalPayState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";
import dayjs from "dayjs";
import { DATE_FORMAT, MODULE_FINAL_PAYS } from "variables/constants";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

const FinalPayForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId ?? 0);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){
			
			const { fpa_lc_date_from, fpa_lc_date_to, fpa_lc_date_from_nt, fpa_lc_date_to_nt, ...rest } = recordData;
	        const initialValues = {
	            ...rest,
				leave_convertion: fpa_lc_date_from && fpa_lc_date_to
				? [dayjs(fpa_lc_date_from), dayjs(fpa_lc_date_to)]
				: undefined,
				leave_convertion_nt: fpa_lc_date_from_nt && fpa_lc_date_to_nt	
				? [dayjs(fpa_lc_date_from_nt), dayjs(fpa_lc_date_to_nt)]
				: undefined,
	        };
			
			
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {  
			const { leave_convertion, leave_convertion_nt, ...forSubmitValues } = values;
			if(leave_convertion){
				forSubmitValues.fpa_lc_date_from = leave_convertion[0].format(DATE_FORMAT);
				forSubmitValues.fpa_lc_date_to = leave_convertion[1].format(DATE_FORMAT);	
			}	
			if(leave_convertion_nt){
				forSubmitValues.fpa_lc_date_from_nt = leave_convertion_nt[0].format(DATE_FORMAT);
				forSubmitValues.fpa_lc_date_to_nt = leave_convertion_nt[1].format(DATE_FORMAT);	
			}	  
			recordData.fpa_id > 0 ? doUpdate(forSubmitValues): doCreate(forSubmitValues); 
			
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="fpa_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
				<div className="grid grid-cols-4">
					<FormItem className="font-medium mb-2"
						name="fpa_employee_id"
						label="Employee"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Select id="fpa_employee_id"
							showSearch
							allowClear={true}
							style={{
								width: 250,
								}}
							options={recordData?.employeeList}
							filterOption={(input, option) =>
								(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
							}
						/>
						: <label className="ps-3 dark:text-white">{recordData?.fpa_employee_name}</label>
						}	                
					</FormItem>
					<FormItem className="font-medium mb-2"
						name="fpa_status_id"
						label="Status"
					>
						{mode === 'edit' ?
						<Select id="fpa_status_id"
							style={{
								width: 150,
								}}
								options={recordData?.statusList}
						/>		            		
						: <label className="ps-3 dark:text-white">{recordData?.fpa_status_name}{recordData?.fpa_latest_validation !== '' && ` (${recordData?.fpa_latest_validation})`}</label>
						}
					</FormItem>
				</div>
				{mode === 'edit' &&
				<>
					<div className="grid grid-cols-4">
						<FormItem className="font-medium mb-2"
							name="leave_convertion"
							label="Leave Conversion (Current Year)"
						>
							<RangePicker className="font-normal"
								format={DATE_FORMAT}
								style={{
									width: 250,
								}}
							/>
						</FormItem> 
						<FormItem className="font-medium mb-2"
							name="fpa_leave_accrued"
							label="Accrued Hours"
						>
							<InputNumber precision={2}
								id="fpa_leave_accrued"
								className="aligned-right-number"
								style={{
									width: 150,
								}}
							/>
						</FormItem>	
						<FormItem className="font-medium mb-2"
							name="fpa_leave_used"
							label="Used Hours"
						>
							<InputNumber precision={2}
								id="fpa_leave_used"
								className="aligned-right-number"
								style={{
									width: 150,
								}}
							/>
						</FormItem>	
					</div>
					<div className="grid grid-cols-4">
						<FormItem className="font-medium mb-2"
							name="leave_convertion_nt"
							label="Leave Conversion (Previous Year)"
						>
							<RangePicker className="font-normal"
								format={DATE_FORMAT}
								style={{
									width: 250,
								}}
							/>
						</FormItem> 
						<FormItem className="font-medium mb-2"
							name="fpa_leave_accrued_nt"
							label="Accrued Hours"
						>
							<InputNumber precision={2}
								id="fpa_leave_accrued_nt"
								className="aligned-right-number"
								style={{
									width: 150,
								}}
							/>
						</FormItem>	
						<FormItem className="font-medium mb-2"
							name="fpa_leave_used_nt"
							label="Used Hours"
						>
							<InputNumber precision={2}
								id="fpa_leave_used_nt"
								className="aligned-right-number"
								style={{
									width: 150,
								}}
							/>
						</FormItem>	
					</div>
				</>
				}	
				<div className="grid grid-cols-4">
					<FormItem className="font-medium  mb-2 col-span-2"
						name="fpa_notes"
						label="Notes"
						initialValue={recordData?.fpa_notes}
					>
						{mode === 'edit' ?
						<TextArea className="py-2"
							rows={2}
							maxLength={500}
						/>
						: <label className="ps-3 dark:text-white">{recordData?.fpa_notes}</label>
						}
					</FormItem>
				</div> 	
	 			<CrudButtons baseRoute="/console/final-pays" mode={mode} recordId={recordId} moduleId={MODULE_FINAL_PAYS}/>			 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.finalPay.finalPayDetails?.data,
  	requesting: state.finalPay.finalPayDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFinalPayDetails(id)),
  	doCreate: (data) => dispatch(doFinalPayCreate(data)),
  	doUpdate: (data) => dispatch(doFinalPayUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPayForm);
